import React from 'react'
import RestrictPage from './views/Restrict'
import ConnectorAI from './views/connectors/AI'
import ConnectorERP from './views/connectors/ERP'
import AgentEmail from './views/agents/email/Email'
import AgentEmailMessages from './views/agents/email/EmailMessages'
import Role from './views/administration/Role'
import Log from './views/system/Logs'
import CursValutar from './views/system/CursValutar'
import Parametri from './views/system/Parametri'
import ConnectorEmailOffice365 from './views/connectors/EmailOffice365'

import TpmParts from './views/tpm/TpmParts'
import TpmOffers from './views/tpm/TpmOffers'
import TpmRfq from './views/tpm/TpmRfq'

import TpmMsgUpload from './views/tpm/TpmMsgUpload'

import TpmAgentConfig from './views/tpm/TpmAgentConfig'
import TpmExcelAgentConfig from './views/tpm/TpmExcelAgentConfig'

import GmailConnectors from './views/connectors/GmailConnectors'
import GmailAgents from './views/agents/gmail/GmailAgents'

const Home = React.lazy(() => import('./views/Home'))
const User = React.lazy(() => import('./views/administration/User'))

const routes = [
  {
    path: '',
    exact: true,
    name: 'Home',
    element: Home,
    permission: 'authenticated',
  },
  {
    path: '/users',
    exact: true,
    name: 'Users',
    element: User,
    permission: 'user-read',
  },
  {
    path: '/roles',
    exact: true,
    name: 'Roles',
    element: Role,
    permission: 'role-read',
  },
  {
    path: '/restriction',
    exact: true,
    name: 'Restriction',
    element: RestrictPage,
  },
  {
    path: '/connectors/email-office365',
    exact: true,
    name: 'EmailOffice365Connectors',
    element: ConnectorEmailOffice365,
    permission: 'connector-read',
  },
  {
    path: '/connectors/ai',
    exact: true,
    name: 'AIConnectors',
    element: ConnectorAI,
    permission: 'connector-read',
  },
  {
    path: '/connectors/erp',
    exact: true,
    name: 'ERPConnectors',
    element: ConnectorERP,
    permission: 'connector-read',
  },
  {
    path: '/agents/emails',
    exact: true,
    name: 'EmailAgents',
    element: AgentEmail,
    permission: 'agent-read',
  },
  {
    path: '/emails',
    exact: true,
    name: 'EmailAgentMessages',
    element: AgentEmailMessages,
    permission: 'agent-email-message-read',
  },
  {
    path: '/logs',
    exact: true,
    name: 'Log',
    element: Log,
    permission: 'log-read',
  },
  {
    path: '/curs-valutar',
    exact: true,
    name: 'CursValutar',
    element: CursValutar,
  },
  {
    path: '/parametri',
    exact: true,
    name: 'Parametri',
    element: Parametri,
  },
  {
    path: '/terms',
    exact: true,
    name: 'Terms',
    element: () => <div>Terms</div>,
  },
  {
    path: '/privacy',
    exact: true,
    name: 'Privacy',
    element: () => <div>Privacy</div>,
  },
	{
	  path: '/tpm/parts',
	  exact: true,
	  name: 'TPM Catalog Piese',
	  element: TpmParts,
	  permission: 'tpm-part-read',
	 },
	 {
	  path: '/tpm/offers',
	  exact: true,
	  name: 'TPM Oferte',
	  element: TpmOffers,
	  permission: 'tpm-offer-read',
	},
	{
	  path: '/tpm/rfq',
	  exact: true,
	  name: 'TPM Cereri de Oferta',
	  element: TpmRfq,
	  permission: 'tpm-rfq-read',
	},
	{
	  path: '/tpm/msg',
	  exact: true,
	  name: 'TPM Upload MSG',
	  element: TpmMsgUpload,
	  permission: 'tpm-part-create',
	},
	{
	  path: '/tpm/agent',
	  exact: true,
	  name: 'TPM Agent Config',
	  element: TpmAgentConfig,
	  permission: 'tpm-part-update',
	},
	{
	  path: '/tpm/excel-agent',
	  exact: true,
	  name: 'TPM Excel Agent Config',
	  element: TpmExcelAgentConfig,
	  permission: 'tpm-part-update',
	},
	{ path: '/connectors/gmail', exact: true, name: 'Gmail Connectors', element: GmailConnectors, permission: 'connector-gmail-read' },
{ path: '/agents/gmail', exact: true, name: 'Gmail Agents', element: GmailAgents, permission: 'agent-gmail-read' },
]

export default routes
